import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = ["value"];
const _hoisted_2 = ["value"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("select", {
    value: $props.modelValue,
    onChange: _cache[0] || (_cache[0] = (...args) => $options.changeOption && $options.changeOption(...args)),
    class: "select"
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.options, (option, id) => {
    return _openBlock(), _createElementBlock("option", {
      key: id,
      value: option.value
    }, _toDisplayString(option.name), 9, _hoisted_2);
  }), 128))], 40, _hoisted_1);
}